<div class="surface-card p-4 shadow-2 border-round">
  <ng-template [ngIf]="isLoadingResults">
    <app-loading></app-loading>
</ng-template>
    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
     <div class="flex justify-start md:justify-start">
     
        <span class="p-input-icon-left mr-2">
            <i class="pi pi-search"></i>
            <input type="text" pInputText placeholder="Cerca"
              (input)="filtraListini($event)" [disabled]="isLoadingResults" />
          </span>
          <button pButton type="button" icon="pi pi-refresh" 
          style="background-color: #6797a3; border-color:#093139; color: #f9f9f9;font-size: 13px;" (click)="loadListini()"
          pTooltip="Aggiorna dati" tooltipPosition="top" 
          ></button>
      </div>
      <div class="flex justify-end md:justify-center">
        <span class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">LISTINO PREZZI</span>
      </div>
      
     <div class="flex justify-end md:justify-end">
    
      <button *ngIf="!this.isDirigenteFirmaPacchetti"
        pButton type="button" icon="pi pi-pen-to-square" 
        pTooltip="Modifica Listino Nazionale" tooltipPosition="top" 
        class="font-['Poppins'] mr-2"
        style="background-color:#68ae7e; color: #000000; border-color: #063032; font-size: 12px;"
        label="Modifica Nazionale"
        (click)="openModificaListinoNazionaleDialog()" 
        [disabled]="isLoadingResults || isDemo">
      </button>
      <button pButton type="button"  icon="pi pi-history" 
          tooltipPosition="top" pTooltip="Storico del listino Nazionale"
          class="font-['Poppins'] mr-2"
          style="background-color:#81b9b0; color: #063032; border-color: #063032; font-size: 12px;"
          label="Storico Nazionale"
          (click)="openStoricoListinoNazionale()"
          [disabled]="isLoadingResults"
          >
      </button>
       <button *ngIf="!this.isDirigenteFirmaPacchetti"
          pButton type="button" icon="pi pi-plus" 
          pTooltip="Crea nuovo Listino" tooltipPosition="top" 
          class="font-['Poppins']"
          style="background-color:cadetblue; color: #162526; border-color:#162526; font-size: 13px;"
          label="Nuovo"
          (click)="openCreaListinoDialog()" 
          [disabled]="isLoadingResults || isDemo">
       </button>
       
     </div>
  </div>
            <div fxFlex="95%" class="mt-2">
              <p-tabView styleClass="tabview-custom" (onChange)="onTabChange($event)" [(activeIndex)]="selectedTabIndex">
                <p-tabPanel >
                  <ng-template pTemplate="header" style="color: #0A122A;">
                    <div class=" font-semibold font-['Poppins']" >IMPRESE</div>
                  </ng-template>
                  <p-table #listiniDT styleClass="p-datatable-sm" [value]="listini" dataKey="id" [(selection)]="selectedListino"
                      [selectionPageOnly]="true" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
                      [rowsPerPageOptions]="[10,25,50]" responsiveLayout="scroll" [paginator]="true"
                      currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                      [globalFilterFields]="['azienda.ragioneSociale']"
                      [loading]="isLoadingResults"
                      [sortField]="'azienda.ragioneSociale'" [sortOrder]="1">

                      <ng-template pTemplate="header">
                          <tr>
                            <th  style="font-size: 14px;">
                                  IMPRESA
                              </th>
                              <th class="text-center" style="font-size: 14px;">
                                REGIONI CONFIGURATE
                            </th>
                              <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Progettazione spostamento infrastruttura/terminazione">
                                  SCL.1
                              </th>
                              <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Sopralluogo Interno alla Scuola - Relazione Tecnica (RET)" >
                                  SCL.2
                              </th>
                              <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="As Built">
                                  SCL.3
                              </th>
                              <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Sopralluogo con esito negativo">
                                  SCL.4
                              </th>
                              <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Installazione prodotto servizio">
                                  SCL.5
                              </th>
                              <th class="text-center" style="font-size: 14px;">
                                PREVENTIVO BASE
                              </th>
                              <th class="text-center" style="font-size: 14px;">
                                ULTIMA MODIFICA
                              </th>
                              <th class="text-center" style="font-size: 14px;" *ngIf="!this.isDirigenteFirmaPacchetti">Azioni</th>

                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-row>
                          <tr>
                           
                              <td> 
                                <p-tag
                                    [value]="row.azienda.ragioneSociale | uppercase"
                                    [style]="{
                                      'background-color': '#326F6F' ,
                                      'color': '#ffffff' ,
                                      'border-radius': '6px',
                                      'padding': '.25em .5rem',
                                      'font-weight': '700',
                                      'font-size': '13px',
                                      'letter-spacing': '.3px;',
                                      'cursor': 'pointer',
                                    }"

                                  class="mr-1" 
                              ></p-tag>
                              </td>
                              <td class="text-center"> 
                                <p-tag *ngIf="row.liguria1 || row.liguria2 || row.liguria3 || row.liguria4 || row.liguria5"
                                    [value]="'LIGURIA'"
                                    [style]="{
                                      'background-color': '#37505C' ,
                                      'color': '#ffffff' ,
                                      'border-radius': '6px',
                                      'padding': '.25em .5rem',
                                      'font-weight': '700',
                                      'font-size': '13px',
                                      'letter-spacing': '.3px;',
                                      'cursor': 'pointer',
                                    }"
                                    tooltipPosition="top" pTooltip="Apri Listino Liguria"
                                    class="mr-1" (click)="openListinoRegione('LIGURIA',row)"
                                 ></p-tag>
                                 <p-tag *ngIf="row.piemonte1 || row.piemonte2 || row.piemonte3 || row.piemonte4 || row.piemonte5"
                                    [value]="'PIEMONTE'"
                                    [style]="{
                                      'background-color': '#C67C4E' ,
                                      'color': '#ffffff' ,
                                      'border-radius': '6px',
                                      'padding': '.25em .5rem',
                                      'font-weight': '700',
                                      'font-size': '13px',
                                      'letter-spacing': '.3px;',
                                      'cursor': 'pointer',
                                    }"
                                    tooltipPosition="top" pTooltip="Apri Listino Piemonte"
                                    class="mr-1" (click)="openListinoRegione('PIEMONTE',row)"
                                 ></p-tag>
                                 <p-tag *ngIf="row.sardegna1|| row.sardegna2 || row.sardegna3 || row.sardegna4 || row.sardegna5"
                                    [value]="'SARDEGNA'"
                                    [style]="{
                                      'background-color': '#615573' ,
                                      'color': '#ffffff' ,
                                      'border-radius': '6px',
                                      'padding': '.25em .5rem',
                                      'font-weight': '700',
                                      'font-size': '13px',
                                      'letter-spacing': '.3px;',
                                      'cursor': 'pointer',
                                    }"
                                    (click)="openListinoRegione('SARDEGNA',row)"
                                    tooltipPosition="top" pTooltip="Apri Listino Sardegna"
                                 ></p-tag>
                              </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500;"  >{{row.listinoNazionale.scl1}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " >{{row.listinoNazionale.scl2}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " tooltipPosition="top" pTooltip="Apri Listino Sardegna">{{row.listinoNazionale.scl3}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " tooltipPosition="top" pTooltip="Apri Listino Sardegna">{{row.listinoNazionale.scl4}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " tooltipPosition="top" pTooltip="Apri Listino Sardegna">{{row.listinoNazionale.scl5}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " tooltipPosition="top" pTooltip="Apri Listino Sardegna">{{row.listinoNazionale.preventivoBase}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " tooltipPosition="top" pTooltip="Apri Listino Sardegna">{{row.modificato?utilService.formattaDataDaDate(row.modificato):utilService.formattaDataDaDate(row.creato)}}</span> </td>
                              <td class="flex justify-content-center align-items-center" *ngIf="!this.isDirigenteFirmaPacchetti">
                               
                                <button *ngIf="!this.isDirigenteFirmaPacchetti && (row)" pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-cart-plus" 
                                class="p-button-rounded p-button-text" tooltipPosition="top" pTooltip="Aggiungi Regione per {{row.azienda.ragioneSociale}}"
                                    (click)="openAggiungiRegioneDialog(row)" 
                                    [disabled]="isDemo"
                                    >
                                </button>
                                <!--  <button pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-pencil" class="p-button-rounded p-button-text" tooltipPosition="top" pTooltip="Modifica Listino"
                                    (click)="openModificaListinoDialog(row)"
                                    >
                                </button> -->
                                <button *ngIf="!this.isDirigenteFirmaPacchetti" pButton pRipple type="button" icon="pi pi-trash"
                                    class="p-button-rounded p-button-text"
                                    (click)="showDeleteListinoDialog(row)"
                                    style="color:red;" tooltipPosition="top" pTooltip="Elimina Listino"
                                    [disabled]="row.id==1 || row.numeroProgetti > 0 || row.numeroUtenti > 0 || isDemo"
                                    >
                                </button>
                              </td> 
                      </ng-template>
                    </p-table> 
                </p-tabPanel>
                <p-tabPanel >
                  <ng-template pTemplate="header" style="color: #0A122A;">
                    <div class=" font-semibold font-['Poppins']" >LIGURIA</div>
                  </ng-template>
                  <p-table #listiniLiguriaDT styleClass="p-datatable-sm" [value]="listiniLiguria" dataKey="id" [(selection)]="selectedListinoLiguria"
                      [selectionPageOnly]="true" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
                      [rowsPerPageOptions]="[10,25,50]" responsiveLayout="scroll" [paginator]="true"
                      currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                      [globalFilterFields]="['azienda.ragioneSociale']"
                      [loading]="isLoadingResults"
                      [sortField]="'azienda.ragioneSociale'" [sortOrder]="1">

                      <ng-template pTemplate="header">
                          <tr>
                            <th  style="font-size: 14px;">
                                  IMPRESA
                              </th>
                              <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Progettazione spostamento infrastruttura/terminazione">
                                  SCL.1
                              </th>
                              <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Sopralluogo Interno alla Scuola - Relazione Tecnica (RET)">
                                  SCL.2
                              </th>
                              <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="As Built">
                                  SCL.3
                              </th>
                              <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Sopralluogo con esito negativo">
                                  SCL.4
                              </th>
                              <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Installazione prodotto servizio">
                                  SCL.5
                              </th>
                              <th class="text-center" style="font-size: 14px;" >
                                PREVENTIVO BASE
                              </th>
                              <th class="text-center" style="font-size: 14px;">
                                ULTIMA MODIFICA
                              </th>
                              <th class="text-center" style="font-size: 14px;">Azioni</th>

                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-row>
                          <tr [ngClass]="{'selected-listino-liguria': isRowLiguriaSelected(row)}">
                           
                              <td> 
                                <p-tag
                                    [value]="row.azienda.ragioneSociale | uppercase"
                                    [style]="{
                                      'background-color': '#326F6F' ,
                                      'color': '#ffffff' ,
                                      'border-radius': '6px',
                                      'padding': '.25em .5rem',
                                      'font-weight': '700',
                                      'font-size': '13px',
                                      'letter-spacing': '.3px;',
                                      'cursor': 'pointer',
                                    }"

                                  class="mr-1"
                              ></p-tag>
                              </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " tooltipPosition="top" pTooltip="Progettazione spostamento infrastruttura/terminazione">{{row.liguria1}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " tooltipPosition="top" pTooltip="Sopralluogo Interno alla Scuola - Relazione Tecnica (RET)">{{row.liguria2}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " tooltipPosition="top" pTooltip="As Built">{{row.liguria3}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " tooltipPosition="top" pTooltip="Sopralluogo con esito negativo">{{row.liguria4}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " tooltipPosition="top" pTooltip="Installazione prodotto servizio">{{row.liguria5}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.preventivoBaseLiguria}} €</span> </td>
                              <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.modificato?utilService.formattaDataDaDate(row.modificato):utilService.formattaDataDaDate(row.creato)}}</span> </td>
                              <td class="flex justify-content-center align-items-center" >
                                  <button pButton type="button" style="color:rgb(131, 166, 104);" icon="pi pi-history" class="p-button-rounded p-button-text" tooltipPosition="top" pTooltip="Storico del listino per la Liguria"
                                    (click)="openStoricoListino(row, 'LIGURIA')"
                                    >
                                </button> 
                                <button *ngIf="!this.isDirigenteFirmaPacchetti" pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-pencil" class="p-button-rounded p-button-text" 
                                tooltipPosition="top" pTooltip="Modifica Listino per la Liguria"
                                    (click)="openModificaRegioneDialog(row, 'LIGURIA')"
                                    [disabled]="isDemo"
                                    >
                                </button>
                                 <button *ngIf="!this.isDirigenteFirmaPacchetti" pButton pRipple type="button" icon="pi pi-eraser"
                                    class="p-button-rounded p-button-text"
                                    (click)="showDeleteConfigurazioneDialog(row, 'LIGURIA')"
                                    style="color:red;" tooltipPosition="top" pTooltip="Elimina Configurazione Liguria"
                                    [disabled]="row.id==1 || row.numeroProgetti > 0 || row.numeroUtenti > 0 || isDemo"
                                    >
                                </button>
                              </td> 
                      </ng-template>
                    </p-table> 
                </p-tabPanel>
                <p-tabPanel >
                  <ng-template pTemplate="header" style="color: #0A122A;">
                    <div class=" font-semibold font-['Poppins']" >PIEMONTE</div>
                  </ng-template>
                  <p-table #listiniPiemonteDT styleClass="p-datatable-sm" [value]="listiniPiemonte" dataKey="id" [(selection)]="selectedListinoPiemonte"
                  [selectionPageOnly]="true" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[10,25,50]" responsiveLayout="scroll" [paginator]="true"
                  currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                  [globalFilterFields]="['azienda.ragioneSociale']"
                  [loading]="isLoadingResults"
                  [sortField]="'azienda.ragioneSociale'" [sortOrder]="1">

                  <ng-template pTemplate="header">
                      <tr >
                        <th  style="font-size: 14px;">
                              IMPRESA
                          </th>
                          <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Progettazione spostamento infrastruttura/terminazione">
                              SCL.1
                          </th>
                          <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Sopralluogo Interno alla Scuola - Relazione Tecnica (RET)">
                              SCL.2
                          </th>
                          <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="As Built">
                              SCL.3
                          </th>
                          <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Sopralluogo con esito negativo">
                              SCL.4
                          </th>
                          <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Installazione prodotto servizio">
                              SCL.5
                          </th>
                          <th class="text-center" style="font-size: 14px;">
                            PREVENTIVO BASE
                          </th>
                          <th class="text-center" style="font-size: 14px;">
                            ULTIMA MODIFICA
                          </th>
                          <th class="text-center" style="font-size: 14px;">Azioni</th>

                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-row>
                      <tr [ngClass]="{'selected-listino-piemonte': isRowPiemonteSelected(row)}">
                      
                          <td> 
                            <p-tag
                                [value]="row.azienda.ragioneSociale | uppercase"
                                [style]="{
                                  'background-color': '#326F6F' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '13px',
                                  'letter-spacing': '.3px;',
                                  'cursor': 'pointer',
                                }"

                              class="mr-1"
                          ></p-tag>
                          </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " >{{row.piemonte1}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " >{{row.piemonte2}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " >{{row.piemonte3}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " >{{row.piemonte4}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; " >{{row.piemonte5}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.preventivoBasePiemonte}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.modificato?utilService.formattaDataDaDate(row.modificato):utilService.formattaDataDaDate(row.creato)}}</span> </td>
                          <td class="flex justify-content-center align-items-center" >
                            <button pButton type="button" style="color:rgb(131, 166, 104);" icon="pi pi-history" class="p-button-rounded p-button-text" tooltipPosition="top" pTooltip="Storico del listino per il Piemonte"
                            (click)="openStoricoListino(row, 'PIEMONTE')"
                                >
                            </button>
                            <button *ngIf="!this.isDirigenteFirmaPacchetti" pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-pencil" class="p-button-rounded p-button-text" 
                            tooltipPosition="top" pTooltip="Modifica Listino per il Piemonte"
                                (click)="openModificaRegioneDialog(row, 'PIEMONTE')"
                                [disabled]="isDemo"
                                >
                            </button>
                            <button *ngIf="!this.isDirigenteFirmaPacchetti" pButton pRipple type="button" icon="pi pi-eraser"
                                    class="p-button-rounded p-button-text"
                                    (click)="showDeleteConfigurazioneDialog(row, 'PIEMONTE')"
                                    style="color:red;" tooltipPosition="top" pTooltip="Elimina Configurazione Piemonte"
                                    [disabled]="isDemo"
                                     >
                                </button>
                            <!-- <button pButton pRipple type="button" icon="pi pi-trash"
                                class="p-button-rounded p-button-text"
                                (click)="showDeleteListinoDialog(row)"
                                style="color:red;" tooltipPosition="top" pTooltip="Elimina Listino"
                                [disabled]="row.id==1 || row.numeroProgetti > 0 || row.numeroUtenti > 0"
                                >
                            </button> -->
                          </td> 
                  </ng-template>
                </p-table> 
                </p-tabPanel>
                
                <p-tabPanel >
                  <ng-template pTemplate="header" style="color: #0A122A;">
                    <div class=" font-semibold font-['Poppins']" >SARDEGNA</div>
                  </ng-template>
                  <p-table #listiniSardegnaDT styleClass="p-datatable-sm" [value]="listiniSardegna" dataKey="id" [(selection)]="selectedListinoSardegna"
                  [selectionPageOnly]="true" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[10,25,50]" responsiveLayout="scroll" [paginator]="true"
                  currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                  [globalFilterFields]="['azienda.ragioneSociale']"
                  [loading]="isLoadingResults"
                  [sortField]="'azienda.ragioneSociale'" [sortOrder]="1">

                  <ng-template pTemplate="header">
                      <tr>
                        <th  style="font-size: 14px;">
                              IMPRESA
                          </th>
                          <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Progettazione spostamento infrastruttura/terminazione">
                              SCL.1
                          </th>
                          <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Sopralluogo Interno alla Scuola - Relazione Tecnica (RET)">
                              SCL.2
                          </th>
                          <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="As Built">
                              SCL.3
                          </th>
                          <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Sopralluogo con esito negativo">
                              SCL.4
                          </th>
                          <th class="text-center" style="font-size: 14px;" tooltipPosition="top" pTooltip="Installazione prodotto servizio">
                              SCL.5
                          </th>
                          <th class="text-center" style="font-size: 14px;">
                            PREVENTIVO BASE
                          </th>
                          <th class="text-center" style="font-size: 14px;">
                            ULTIMA MODIFICA
                          </th>
                          <th class="text-center" style="font-size: 14px;">Azioni</th>

                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-row>
                      <tr [ngClass]="{'selected-listino-sardegna': isRowSardegnaSelected(row)}">
                      
                          <td> 
                            <p-tag
                                [value]="row.azienda.ragioneSociale | uppercase"
                                [style]="{
                                  'background-color': '#326F6F' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '13px',
                                  'letter-spacing': '.3px;',
                                  'cursor': 'pointer',
                                }"
                          ></p-tag>
                          </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.sardegna1}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.sardegna2}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.sardegna3}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.sardegna4}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.sardegna5}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.preventivoBaseSardegna}} €</span> </td>
                          <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{row.modificato?utilService.formattaDataDaDate(row.modificato):utilService.formattaDataDaDate(row.creato)}}</span> </td>
                          <td class="flex justify-content-center align-items-center" >
                            <button pButton type="button" style="color:rgb(131, 166, 104);" icon="pi pi-history" class="p-button-rounded p-button-text" tooltipPosition="top" pTooltip="Storico del listino per la Sardegna"
                            (click)="openStoricoListino(row, 'SARDEGNA')"
                                >
                            </button>
                            <button *ngIf="!this.isDirigenteFirmaPacchetti" pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-pencil" class="p-button-rounded p-button-text" tooltipPosition="top" 
                                pTooltip="Modifica Listino per la Sardegna"
                                (click)="openModificaRegioneDialog(row, 'SARDEGNA')"
                                [disabled]="isDemo"
                                >
                            </button>
                            <button *ngIf="!this.isDirigenteFirmaPacchetti" pButton pRipple type="button" icon="pi pi-eraser"
                                    class="p-button-rounded p-button-text"
                                    (click)="showDeleteConfigurazioneDialog(row, 'SARDEGNA')"
                                    style="color:red;" tooltipPosition="top" pTooltip="Elimina Configurazione Sardegna"
                                    [disabled]="isDemo"
                                     >
                                </button>
                           <!--  <button pButton pRipple type="button" icon="pi pi-trash"
                                class="p-button-rounded p-button-text"
                                (click)="showDeleteListinoDialog(row)"
                                style="color:red;" tooltipPosition="top" pTooltip="Elimina Listino"
                                [disabled]="row.id==1 || row.numeroProgetti > 0 || row.numeroUtenti > 0"
                                >
                            </button> -->
                          </td> 
                  </ng-template>
                </p-table> 
                </p-tabPanel>
              </p-tabView>
               <!--  -->
            </div>
		</div>

<p-dialog [(visible)]="showDeleteConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
    <span class="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
        <i class="pi pi-trash text-5xl"></i>
    </span>
    <div class="font-medium text-2xl text-900">ELIMINAZIONE LISTINO</div>
</div>
<p class="line-height-3 p-0 m-0">
   Confermi di voler eliminare il listino per l'impresa <span style="font-weight: bold;">{{selectedListino?selectedListino.azienda.ragioneSociale.toUpperCase():''}}</span>?
</p>
<ng-template pTemplate="footer">
    <div class=" border-top-1 surface-border pt-3 flex">
        <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showDeleteConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
        <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaEliminazioneListino(true)" label="CONFERMA" class="w-6 ml-2"></button>
    </div>
</ng-template>
</p-dialog> 

<p-dialog [(visible)]="showDeleteConfigurazioneConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
    <span class="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
        <i class="pi pi-trash text-5xl"></i>
    </span>
    <div class="font-medium text-2xl text-900">ELIMINAZIONE CONFIGURAZIONE</div>
</div>
<p class="line-height-3 p-0 m-0">
   Confermi di voler eliminare il listino della regione <span style="font-weight: bold;">{{selectedRegione?selectedRegione.toUpperCase():''}}</span> per l'impresa <span style="font-weight: bold;">{{selectedListino?selectedListino.azienda.ragioneSociale.toUpperCase():''}}</span>?
</p>
<ng-template pTemplate="footer">
    <div class=" border-top-1 surface-border pt-3 flex">
        <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showDeleteConfigurazioneConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
        <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaEliminazioneConfigurazione(true)" label="CONFERMA" class="w-6 ml-2"></button>
    </div>
</ng-template>
</p-dialog> 


<p-toast position="top-center"></p-toast>
